import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RichTextProps {
    html: string
    className?: string
}

/**
 * Renders a rich text field from the CMS. Every rich text field on the site goes through here,
 * and its whole look lives in src/styles/rich-text.css under the .rich-text class.
 */
export const RichText: FC<RichTextProps> = ({ html, className }): ReactNode => {
    return <div className={cn('rich-text', className)} dangerouslySetInnerHTML={{ __html: html }} />
}
